import type { ReactElement } from 'react';
import { useParams, useSearchParams } from 'react-router';
import {
  CUSTOMIZE_COLOR_PARAM,
  CUSTOMIZE_DESIGN_PARAM,
  parseSizeQuantities,
  SIZE_QUANTITIES_PARAM,
} from '@/shared/config';
import { SitePageShell } from '@/shared/ui';
import { CustomizeEditor } from '@/widgets/customize-editor';
import { SiteHeader } from '@/widgets/site-header';

/**
 * 고객 커스터마이징(/store/:productId/customize[?designId=][&color=]). 라우트 파라미터를 읽어 에디터 위젯을 헤더 아래에 둔다.
 * `color` 는 상세에서 고른 색상 — 새 문서를 열 때만 처음 색상으로 쓴다(저장 디자인·임시 보관본이 있으면 그 색상 그대로).
 * 본문 좌우 여백은 사이트 공통(px-5 · sm:px-8 · xl:px-14)을 그대로 쓴다.
 * 넓은 화면에서는 에디터가 헤더 아래 화면 높이를 채우므로 푸터를 두지 않는다(페이지 스크롤 없음).
 */
export const CustomizePage = (): ReactElement => {
  const { productId = '' } = useParams();
  const [searchParams] = useSearchParams();
  const designId = searchParams.get(CUSTOMIZE_DESIGN_PARAM);
  const preferredColorId = searchParams.get(CUSTOMIZE_COLOR_PARAM);
  const initialSizes = parseSizeQuantities(searchParams.get(SIZE_QUANTITIES_PARAM));

  return (
    <SitePageShell
      header={<SiteHeader />}
      footer={null}
      className="pt-4 pb-0 sm:pt-6 sm:pb-0 lg:flex lg:h-[calc(100dvh-5rem-1px)] lg:min-h-0 lg:flex-none lg:flex-col lg:pb-8"
    >
      <CustomizeEditor
        productId={productId}
        designId={designId}
        preferredColorId={preferredColorId}
        initialSizes={initialSizes}
      />
    </SitePageShell>
  );
};
